export default __webpack_public_path__ + "static/media/about-team-will-crozier.395feb7d.png";